import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingQuestIntros = function () { return utilBalancing.getBalancing().QuestIntros; };
export var selectBalancingQuestIntro = memoize(function (id) {
    return selectBalancingQuestIntros().get(id);
});
export var balancingQuestIntrosMemoizedFunctions = [
    selectBalancingQuestIntros,
    selectBalancingQuestIntro,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingQuestIntros.ts
// module id = 483
// module chunks = 3